/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SocialLoginRequest
 */
export interface SocialLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof SocialLoginRequest
     */
    accessToken: string;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginRequest
     */
    idToken?: string;
}

/**
 * Check if a given object implements the SocialLoginRequest interface.
 */
export function instanceOfSocialLoginRequest(value: object): value is SocialLoginRequest {
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    return true;
}

export function SocialLoginRequestFromJSON(json: any): SocialLoginRequest {
    return SocialLoginRequestFromJSONTyped(json, false);
}

export function SocialLoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SocialLoginRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['access_token'],
        'idToken': json['id_token'] == null ? undefined : json['id_token'],
    };
}

  export function SocialLoginRequestToJSON(json: any): SocialLoginRequest {
      return SocialLoginRequestToJSONTyped(json, false);
  }

  export function SocialLoginRequestToJSONTyped(value?: SocialLoginRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'access_token': value['accessToken'],
        'id_token': value['idToken'],
    };
}

